import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink } from "lucide-react";

/**
 * One-tap "Join our Discord" invite. Reads the invite URL from the public
 * community endpoint; hides itself entirely when the admin hasn't set one.
 */
export default function JoinDiscordCard() {
  const [url, setUrl] = useState("");

  useEffect(() => {
    api.get("/community/discord-invite")
      .then((r) => setUrl(r.data?.url || ""))
      .catch(() => setUrl(""));
  }, []);

  if (!url) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="join-discord-card"
      className="group relative flex items-center justify-between gap-4 border border-[#5865F2] bg-gradient-to-r from-[#5865F2]/15 via-[#5865F2]/5 to-transparent p-5 sm:p-6 overflow-hidden hover:from-[#5865F2]/25 transition-colors"
    >
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 flex items-center justify-center bg-[#5865F2] text-white shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
            <path d="M20.317 4.369A19.79 19.79 0 0 0 16.558 3.2a.075.075 0 0 0-.079.037c-.34.607-.719 1.4-.984 2.024a18.36 18.36 0 0 0-5.487 0 12.68 12.68 0 0 0-1-2.024.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 5.171 4.369a.07.07 0 0 0-.032.027C2.593 8.045 1.9 11.63 2.24 15.17a.082.082 0 0 0 .031.055 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.31 14.31 0 0 0 1.226-1.994.075.075 0 0 0-.041-.105 13.13 13.13 0 0 1-1.875-.893.076.076 0 0 1-.008-.127c.126-.094.252-.192.373-.291a.075.075 0 0 1 .078-.01c3.927 1.793 8.18 1.793 12.061 0a.074.074 0 0 1 .079.01c.12.099.246.198.373.292a.076.076 0 0 1-.006.127 12.31 12.31 0 0 1-1.876.892.076.076 0 0 0-.041.106c.36.7.772 1.365 1.226 1.993a.077.077 0 0 0 .084.029 19.84 19.84 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-4.088-.838-7.643-3.549-10.774a.06.06 0 0 0-.031-.028zM8.02 13.041c-1.182 0-2.157-1.085-2.157-2.419 0-1.333.957-2.418 2.157-2.418 1.21 0 2.176 1.094 2.157 2.418 0 1.334-.957 2.42-2.157 2.42zm7.974 0c-1.183 0-2.158-1.085-2.158-2.419 0-1.333.957-2.418 2.158-2.418 1.21 0 2.176 1.094 2.157 2.418 0 1.334-.947 2.42-2.157 2.42z" />
          </svg>
        </div>
        <div className="min-w-0">
          <div className="text-[10px] font-mono tracking-[0.3em] text-[#8b93f9] uppercase mb-1">/ COMMUNITY</div>
          <div className="font-heading text-xl sm:text-2xl font-black uppercase tracking-tight">Join our Discord</div>
          <div className="text-xs text-gray-400 mt-1">Live match chat, roster news, scrim pickups — all in one place.</div>
        </div>
      </div>
      <div className="hidden sm:flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-white group-hover:text-[#8b93f9] transition-colors">
        Open <ExternalLink className="w-3.5 h-3.5" />
      </div>
    </a>
  );
}
